(function () {
  'use strict';
  /* PV T18 — 产品图放大的键盘入口 (WCAG 2.1.1). s495 build, codex r1 F1/F2 折入.
     ------------------------------------------------------------------
     零视觉契约 (Andrew s495 硬约束):
       - 不新增 tab stop —— slick 已在 .slick-current 上给 tabindex="0", 其余 slide 为 -1
       - 不改 markup / 不写任何 CSS
       - 既有粉色 focus 环 (pv-override.css:971-975 [tabindex]:focus-visible) 原样复用
     本文件只补一个行为: 焦点在幻灯片上按 Enter = 等同鼠标点击当前那张图的 .media
     ------------------------------------------------------------------
     只在 Enter 路径生效 => 鼠标开/关灯箱的用户完全不受本文件影响 (观察器只在 Enter 分支武装)
     不拦 Space (保留页面滚动) / 不拦方向键 (保留 slick 翻页) */

  var OPEN_POLL_MS   = 50;      // 实测灯箱在 click 后同步出现; 轮询仅作防御 (见 raw/probe6)
  var OPEN_POLL_MAX  = 6;       // ≤300ms 上限, 超时即放弃 (零观察器 / 零焦点变更)
  var WATCH_MAX_MS   = 600000;  // F2: 观察器有界上限 10min, 防永活泄漏

  function lightboxEl() {
    return document.querySelector('.fancybox-container');
  }

  function currentMedia(gallery) {
    return gallery.querySelector('.productView-image.slick-current .media[data-fancybox]')
        || gallery.querySelector('.productView-image .media[data-fancybox]');
  }

  /* F1: 只把焦点还给"仍然是 current / 仍可聚焦 / 未被 aria-hidden"的 slide.
     实测 (raw/probe4 + probe5): slick 翻页后 activeElement 停在旧 slide 而 .slick-current 已前移,
     且非 current 的 slide 会被打上 aria-hidden="true" + tabindex="-1" —— 焦点还给它 = 聚焦隐藏元素. */
  function eligibleSlide(el) {
    if (!el || !document.body.contains(el)) return null;
    if (!el.classList.contains('slick-current')) return null;
    if (el.getAttribute('tabindex') !== '0') return null;
    if (el.getAttribute('aria-hidden') === 'true') return null;
    return el;
  }

  function restoreFocus(originSlide, gallery) {
    var target = eligibleSlide(originSlide)
              || eligibleSlide(gallery.querySelector('.productView-image.slick-current'));
    if (!target || typeof target.focus !== 'function') return;   // 一个都不合格 => 不动焦点
    try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
  }

  /* F2: 只有在确认灯箱真的开了之后才挂关闭观察器, 且有界.
     实测 (raw/probe6): 关闭时 fancybox 把 .fancybox-container 从 body 移除 (非隐藏),
     产生恰好 1 次 body childList mutation —— 故 childList 观察即可捕获关闭. */
  function armCloseWatcher(originSlide, gallery) {
    if (!window.MutationObserver) return;
    var done = false, timer = null;
    function finish(doRestore) {
      if (done) return;
      done = true;
      obs.disconnect();
      if (timer) clearTimeout(timer);
      if (doRestore) restoreFocus(originSlide, gallery);
    }
    var obs = new MutationObserver(function () {
      if (lightboxEl()) return;      // 灯箱还在 => 与本次无关的 body 变动, 忽略
      finish(true);
    });
    obs.observe(document.body, { childList: true });
    timer = setTimeout(function () { finish(false); }, WATCH_MAX_MS);  // 超时: 只解绑, 不动焦点
  }

  function afterOpen(originSlide, gallery, tries) {
    if (lightboxEl()) { armCloseWatcher(originSlide, gallery); return; }
    if (tries <= 0) return;          // 灯箱没开 (fancybox 缺席/未初始化) => 零观察器, 零焦点变更
    setTimeout(function () { afterOpen(originSlide, gallery, tries - 1); }, OPEN_POLL_MS);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;

    var slide = e.target && e.target.closest && e.target.closest('.productView-image');
    if (!slide) return;
    if (e.target !== slide) return;  // 只在幻灯片本体响应, 不劫持其内部链接/按钮

    var gallery = slide.closest('.productView-images') || document;
    var media = currentMedia(gallery);
    if (!media) return;

    e.preventDefault();
    var originSlide = media.closest('.productView-image');  // F1: 跟随"被打开的那张图", 非"被按键的 slide"
    media.click();                                          // 复用既有 fancybox 3.5.7 点击路径
    afterOpen(originSlide, gallery, OPEN_POLL_MAX);
  });
})();
